<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <activity-dialog ref="activeDialogRef" />
    <agree-privacy-dialog />
  </div>
</template>

<script>
import ActivityDialog from '@/components/dialog/activity-dialog'
import AgreePrivacyDialog from '@/components/dialog/agree-privacy-dialog'

export default {
  components: {
    ActivityDialog,
    AgreePrivacyDialog
  },
  provide: function () {
    return {
      openActiveDialog: this.openActiveDialog
    }
  },
  methods: {
    openActiveDialog() {
      this.$refs.activeDialogRef.open()
    }
  }
}
</script>

<style lang="scss">
@import 'style/base';

#app {
  font-size: 14px;
  color: #333;
}
</style>
